import styled from "styled-components";

const RightImageTitle = styled.div`
  margin: 25px 0 15px;
  font-size: 24px;
  font-weight: 800;
  text-transform: lowercase;

  @media (max-width: 1599px) {
    margin: 10px 0 10px 10px;
    font-size: 20px;
  }
  @media (max-width: 1199px) {
    font-size: 16px;
  }
  @media (max-width: 575px) {
    line-height: normal;
    font-size: 14px;
  }
`;

export default RightImageTitle;
